export enum TransactionCategory {
  CapitalCalls = "Capital calls",
  Distributions = "Distributions",
  Redemptions = "Redemptions",
  NetIncome = "Net income",
}

export const getCapitalActivityLabel = (showCapitalActivityLabelCanopy: boolean): string =>
  showCapitalActivityLabelCanopy ? "Capital activity" : "Redemptions";

export const getCapitalActivityCopy = (
  showCapitalActivityLabelCanopy: boolean,
): { singular: string; plural: string } =>
  showCapitalActivityLabelCanopy
    ? { singular: "capital activity", plural: "capital activities" }
    : { singular: "redemption", plural: "redemptions" };
